import { Component, OnInit, DestroyRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { UserRegisterForm } from '../../../../_forms/user-register.form';
import { AuthService } from '../../../../_services/auth.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ButtonComponent } from '../../../../shared/components/button/button.component';

@Component({
  selector: 'app-register-incubator',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, RouterModule, ButtonComponent],
  templateUrl: './register-incubator.component.html',
  styleUrl: './register-incubator.component.css',
})
export class RegisterIncubatorComponent implements OnInit {
  incubatorForm!: UserRegisterForm;
  userData: any;
  loading = false;
  errorMessage = '';

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private auth: AuthService,
    private destroyRef: DestroyRef
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      if (!params['email']) {
        this.router.navigate(['/auth/register']);
        return;
      }

      this.userData = params;

      this.incubatorForm = new UserRegisterForm();
      this.incubatorForm.patchValue(this.userData);
    });
  }

  submit(): void {
    if (this.incubatorForm.invalid || this.loading) {
      this.incubatorForm.markAllAsTouched();
      return;
    }

    this.loading = true;
    this.errorMessage = '';

    const finalData = { ...this.incubatorForm.value, isIncubator: true };

    this.auth
      .register(finalData)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: () => {
          this.loading = false;
          const email = finalData.email;
          this.router.navigate(['/auth/check-email'], { state: { email } });
        },
        error: (err) => {
          this.loading = false;
          this.errorMessage =
            err.error?.message || 'Registration failed. Please try again.';
        },
      });
  }
}
